import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { sellerMeta } from '../routes/metaData'
const DefaultSellerScreen = observer((props: any) => {
   const history = useHistory()
   useEffect(() => {
      history.push(sellerMeta[0].path)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return null
})

export default DefaultSellerScreen
